<div
  class="relative mx-auto w-full max-w-[352px]"
  role="dialog"
  aria-modal="true"
  aria-labelledby="network-offline-title"
  aria-describedby="network-offline-description"
>
  <button
    type="button"
    class="absolute right-[-8px] top-[-8px] flex h-10 w-10 items-center justify-center rounded-full bg-white text-neutral-gray-900 shadow-[0_2px_10px_rgba(0,56,139,0.12),0_0_4px_rgba(169,188,217,0.05)] transition-colors hover:bg-neutral-gray-200"
    aria-label="Cerrar"
    (click)="onClose()"
  >
    <app-svg-icon [iconName]="SvgIcon.CLOSE_MODAL" [size]="20"></app-svg-icon>
  </button>

  <div class="mb-6 flex justify-center">
    <img
      src="assets/icons/error-network.svg"
      alt="Sin conexión"
      class="h-[110px] w-[110px] object-contain"
    />
  </div>

  <div class="mb-6 text-center">
    <h2
      id="network-offline-title"
      class="mb-4 text-[20px] font-semibold leading-[1.2] text-neutral-gray-900"
    >
      {{ title }}
    </h2>

    <p
      id="network-offline-description"
      class="text-[14px] leading-[1.5] text-neutral-gray-700"
    >
      {{ message }}
    </p>
  </div>
  <div class="mb-[46px]">
    <ui-button
      class="font-bold w-full"
      [variant]="'primary'"
      [size]="'x-large'"
      [fullWidth]="true"
      (clicked)="onRetry()"
    >
      {{ retryLabel }}
    </ui-button>
  </div>
</div>
